import styled from "styled-components/macro";
import { useScenesMigrationStore } from "../../../stores/scenesMigrationStore";
import { themeVariables } from "../../../themeVariables";
import { useProjectStore } from "../../../stores/projectStore";
import Project from "../../../models/Project";
import InlineSVG from "react-inlinesvg";

const Container = styled.div`
  background: ${themeVariables.menuColorFullscreen};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin: 10px;
  margin-left: 0px;
  margin-right: 10px;
  border-radius: 10px;
  border: 1px solid ${themeVariables.divider};
  padding: 8px 10px;

  button {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

const RightText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
  color: ${themeVariables.grey0};
  text-align: left;
  .subtext {
    font-size: 12px;
  }
  .text-with-emoji {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;

    svg {
      margin-bottom: 1px;
      margin-left: -2px;
      path {
        fill: ${themeVariables.grey0};
      }
    }
  }
`;

const LeftButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

const LearnMoreButton = styled.button`
  background: transparent !important;
  color: ${themeVariables.grey0} !important;
  border: 0 !important;
  height: 40px !important;
  font-size: 16px !important;
`;

const UpdateNowButton = styled.button`
  background: transparent !important;
  color: ${themeVariables.primaryCTAHighContrast} !important;
  border: 0 !important;
  height: 40px !important;
  font-size: 16px !important;
`;

function ScenesUpgrade() {
  const project = useProjectStore((state) => state.project);
  const setIsOpen = useScenesMigrationStore((state) => state.setModalOpen);
  const setActive = useScenesMigrationStore((state) => state.setActive);

  if (project.useScenes) {
    return null;
  }

  return (
    <Container>
      <RightText>
        <p className="text-with-emoji">
          <InlineSVG
            src="/assets/AI-sparkle.svg"
            height="18"
            width="18"
          />
          Get better prose with Muse - our new AI made just for fiction!
        </p>
        <p className="subtext">To use Muse, update this project to use Scenes. (It'll update automatically on July 7th.)</p>
      </RightText>
      <LeftButtons>
        <LearnMoreButton onClick={() => setIsOpen(project.id, true)}>Learn More</LearnMoreButton>
        <UpdateNowButton
          onClick={async () => {
            await Project.convertToScenes(project.id, true);
            setIsOpen(project.id, true);
            setActive(project.id, true);
          }}
        >
          Update Now
        </UpdateNowButton>
      </LeftButtons>
    </Container>
  );
}

export default ScenesUpgrade;
